import React, { Fragment } from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Button from '../UI/CustomButtons/Button';

import totalStyle from '../../assets/jss/coscef/views/totalStyle';

const useStyles = makeStyles(totalStyle);

const ButtonAdd = (props) => {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer className={classes.titleRow}>
        <GridItem md={4} className={classes.mlAuto}>
          <div className={classes.moveTo}>
            <Button
              color='dark'
              round
              className={classes.floatRight}
              onClick={(e) => {
                e.preventDefault();
                props.history.push('/crear-' + props.nombreComponente);
              }}
            >
              Crear {props.nombreComponente}
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

export default withRouter(ButtonAdd);
